import React from 'react';
import cn from 'classnames';
import sumBy from 'lodash/sumBy';
import { getDateLabelByPeriod } from '@/creditflowresearch/ui/common/components/FinsightChart/helpers';
import { Periods } from '@/creditflowresearch/ui/common/constants';
import { IChartTooltipData } from '@/creditflowresearch/domain/vo/Bond/IChartTooltipData';
import { roundChartValue } from '@/creditflowresearch/ui/components/bonds/Charts/helpers';

import styles from '@/creditflowresearch/ui/common/components/MarketChart/chartTooltip.module.scss';

interface IProps {
  data: IChartTooltipData[],
  period: Periods,
  withPercent: boolean,
}

const HeaderTooltip = ({ data, period, withPercent }: IProps) => {
  const [{ x: currentTimestamp }] = data;

  const calculatedDealCount = sumBy(data, 'dealCount');
  const calculatedDealSize = sumBy(data, 'dealSize');

  const headerClassName = cn(styles.item, styles.header, styles.itemStacked);

  return (
    <div className={ headerClassName }>
      <span className={ cn(styles.itemName, styles.headerDate) }>
        { getDateLabelByPeriod(currentTimestamp, period) }
      </span>
      <span className={ styles.itemDealCount }>
        { calculatedDealCount.toLocaleString('en-US') }
      </span>
      <span className={ styles.itemDealSize }>
        ${ roundChartValue(calculatedDealSize) }
      </span>
      {
        withPercent && <span className={ styles.itemPercent } />
      }
    </div>
  );
};

export default HeaderTooltip;
